import React from 'react';
import { categories } from '../../utils/categoryUtils';

/**
 * Search and filter component for the data table
 * 
 * @param {Object} props - Component props
 * @param {string} props.searchTerm - Current search term
 * @param {Function} props.setSearchTerm - Function to update search term
 * @param {string} props.selectedCategory - Currently selected category
 * @param {Function} props.setSelectedCategory - Function to update selected category
 * @param {Array} props.categories - Available category options
 */
const SearchFilters = ({
  searchTerm,
  setSearchTerm,
  selectedCategory,
  setSelectedCategory,
  categories: categoryOptions = categories
}) => {
  return (
    <div className="flex flex-col md:flex-row mb-4 gap-2">
      <div className="md:w-1/2">
        <input
          type="text"
          placeholder="Search tasks..."
          className="w-full p-3 border rounded text-base"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          aria-label="Search tasks"
        />
      </div>
      <div className="md:w-1/2">
        <select
          className="w-full p-3 border rounded text-base"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          aria-label="Filter by category"
        >
          {categoryOptions.map(category => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SearchFilters;
